import { SxProps } from '@mui/material'

interface RadioStyles {
  formControlLabel: SxProps
  radioLabelWrapper: SxProps
  radioLabel: SxProps
  radioGroupTitle: SxProps
}

export const radioStyles: RadioStyles = {
  formControlLabel: {
    ml: -1,
    gap: 0.5,
  },
  radioLabelWrapper: {
    flex: 1,
  },
  radioLabel: {
    color: 'text.secondary700',
  },
  radioGroupTitle: {
    color: 'text.primary900',
  },
}
